import { render, staticRenderFns } from "./Rulebased.vue?vue&type=template&id=48b088e8&scoped=true&"
import script from "./Rulebased.vue?vue&type=script&lang=js&"
export * from "./Rulebased.vue?vue&type=script&lang=js&"
import style0 from "./Rulebased.vue?vue&type=style&index=0&id=48b088e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b088e8",
  null
  
)

export default component.exports